import React, { useState, useEffect, useContext } from 'react';
import '../App.css';
import axios from 'axios';
import { GrupoContext } from '../GrupoContext';
import Sidebar from '../componenteExtra/SidebarStaff';
import SessionManager from '../componenteExtra/SessionManager';

const AsignacionesEnPausa = () => {
    const { grupo: staffName } = useContext(GrupoContext);
    const [activities, setActivities] = useState([]);
    const [nombreGet, setNombreGet] = useState('');

    const token = localStorage.getItem("access_token");

    useEffect(() => {
        // Restaurar el estado de nombreGet desde localStorage
        const savedNombreGet = localStorage.getItem('nombre_get');
        if (savedNombreGet) {
            setNombreGet(savedNombreGet);
        }

        // Cargar actividades en pausa si el nombre está disponible
        if (savedNombreGet) {
            fetchPausedActivities(savedNombreGet);
        }
    }, []);

    useEffect(() => {
        // Guardar el nombre en localStorage si cambia
        if (nombreGet) {
            localStorage.setItem('nombre_get', nombreGet);
        }
    }, [nombreGet]);

    const fetchPausedActivities = async (nombre) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/get_paused_assignments/${nombre}`, 
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                },
            )
            setActivities(response.data);
        } catch (error) {
            console.error('Error fetching paused assignments:', error);
        }
    };

    const totalActividades = activities.length;
    
    return (
        <div className="app">
            <SessionManager />
            <Sidebar />
            <div className="main-content">
                <div className="main-panel">
                    <h1>Asignaciones pausadas - {nombreGet}</h1>
                    <h2>Total Actividades: {totalActividades}</h2>
                    <div className="activities-table-container">
                        <table className="activities-table">
                            <thead>
                                <tr>
                                    <th>Código de Proyecto</th>
                                    <th>Razón Social</th>
                                    <th>Filial</th>
                                    <th>Tipo de trabajo</th>
                                    <th>Regulación</th>
                                    <th>Socio de auditoría</th>
                                    <th>Numero Grupo</th>
                                    <th>Rubro GET</th>
                                    <th>Nombre Actividad GET</th>
                                    <th>Jefe de Grupo</th>
                                    <th>Subrogante</th>
                                    <th>Fecha Inicio</th>
                                    <th>Fecha Termino</th>
                                    <th>Horas Trabajadas</th>
                                    <th>Estado Pausa</th>
                                </tr>
                            </thead>
                            <tbody>
                                {activities.map((activity, index) => (
                                    <tr key={index}>
                                        <td>{activity.codigo_proyecto}</td>
                                        <td>{activity.razon_social}</td>
                                        <td>{activity.filial}</td>
                                        <td>{activity.tipo_solicitud}</td>
                                        <td>{activity.tipo_regulacion}</td>
                                        <td>{activity.encargado_auditoria}</td>
                                        <td>{activity.numero_grupo}</td>
                                        <td>{activity.rubro_get}</td>
                                        <td>{activity.nombre_actividad_get}</td>
                                        <td>{activity.jefe_grupo}</td>
                                        <td>{activity.subrogante}</td>
                                        <td>{activity.fecha_de_inicio}</td>
                                        <td>{activity.fecha_de_termino}</td>
                                        <td>{activity.horas_get}</td>
                                        <td>{activity.pausa}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AsignacionesEnPausa;
